import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const showAddEventModal = () => ({ type: Modal.toggleModalConstant(Constants.ADD_EVENT) })

export interface EditEventModalAction extends Redux.Action {
  event: Types.Event,
}
export const editModal = (event: Types.Event): EditEventModalAction =>
  ({ type: Constants.EDIT_EVENT, event })

export const updateAddEventModalField = (field: Modal.ModalField) =>
  ({ type: Modal.updateModalConstant(Constants.ADD_EVENT), field })

const fetchEventUrl = (viewState: Types.QueryState): string => `${Constants.SERVER_RESOURCE}/` + viewState.community

export type FetchEvents = Request.Request
export const fetchAllEvents: FetchEvents = (
  viewState: Types.QueryState,
) =>
  Request.requestActionCreator(Constants.FETCH_EVENTS)({
    method: 'GET',
    url: fetchEventUrl(viewState),
  })

export type FetchScheduleTypes = Request.Request
export const fetchAllScheduleTypes: FetchScheduleTypes = () =>
  Request.requestActionCreator(Constants.FETCH_SCHEDULE_TYPES)({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/schedule-types`,
  })

export const createEvent: Modal.Submit<Types.ModalData> = (communityIdentifier: string, payload: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_EVENT)({
    method: 'POST',
    payload,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}`,
  })

export const updateEvent: Modal.Submit<Types.ModalData> = (communityIdentifier: string, payload: Types.ModalData) =>
  Request.requestActionCreator(Constants.UPDATE_EVENT)({
    method: 'PUT',
    payload,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${payload.id}`,
  })

export const updateUserCommunityPreferenceStatus: IsActive.UpdateStatusAction = (
  community: string,
  stateChange: IsActive.StateChange,
) =>
  Request.requestActionCreator(Constants.UPDATE_USER_COMMUNITY_PREFERENCE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE_USER_COMMUNITY_PREFERENCE}` +
      `/${stateChange.props.dataItem.community_identifier}/${stateChange.id}`,
  })

export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_EVENT)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${stateChange.props.dataItem.community_identifier}/${stateChange.id}`,
  })

export const createOrUpdate = (community: string, data: Types.ModalData) =>
  data.id ? updateEvent(community, data) : createEvent(community, data)

export interface SearchAction extends Redux.Action {
  term: string,
}

export type UpdateSearchAction = (searchTerm: string) => any
export const updateSearch: UpdateSearchAction = (searchTerm: string) => ({
  term: searchTerm,
  type: Constants.UPDATE_REPORTS_SEARCH_STRING,
})

export const updateUI = (viewState: any) => ({
  filter: viewState.filter,
  sort: viewState.sort,
  type: Constants.SELECT_SORT_AND_FILTER,
})



// WEBPACK FOOTER //
// ./src/pages/admin-reports/actions.ts